import React, { useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import { companyInfo } from '../mock';

const TextUsButton = () => {
  const [showOptions, setShowOptions] = useState(false);

  const handleTextClick = () => {
    // Open SMS app with pre-filled message
    const message = encodeURIComponent("Hi! I need pest control services. Can you help?");
    window.location.href = `sms:${companyInfo.phoneRaw}?body=${message}`;
  };

  return (
    <>
      {/* Floating Text Us Button - Larger Size */}
      {!showOptions && (
        <button
          onClick={() => setShowOptions(true)}
          className="fixed bottom-6 right-6 w-20 h-20 rounded-full shadow-2xl z-50 flex flex-col items-center justify-center hover:scale-110 transition-transform duration-200"
          style={{ background: 'var(--gradient-button)' }}
          aria-label="Text us"
        >
          <MessageSquare size={24} color="white" />
          <span className="text-white text-xs font-bold mt-1">SMS</span>
        </button>
      )}

      {/* Text Options Panel */}
      {showOptions && (
        <div className="fixed bottom-24 right-6 w-80 md:w-96 bg-white rounded-2xl shadow-2xl z-50 border" style={{ borderColor: 'var(--border-light)' }}>
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: 'var(--border-light)', background: 'var(--gradient-button)' }}>
            <div className="flex items-center gap-2">
              <MessageSquare size={20} color="white" />
              <div>
                <h4 className="font-semibold text-white text-sm">Text Us Now</h4>
                <p className="text-xs text-white opacity-90">We respond quickly!</p>
              </div>
            </div>
            <button onClick={() => setShowOptions(false)} className="text-white hover:opacity-80">
              <X size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="text-center mb-6">
              <div 
                className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
                style={{ background: 'var(--accent-wash)' }}
              >
                <MessageSquare size={32} style={{ color: 'var(--accent-text)' }} />
              </div>
              <h3 className="heading-3 mb-2">Text Message Available</h3>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                Send us a text message for quick pest control help. We'll respond within minutes!
              </p>
            </div>

            {/* Phone Number Display */}
            <div 
              className="p-4 rounded-lg mb-4 text-center"
              style={{ background: 'var(--bg-section)' }}
            >
              <p className="body-small mb-2" style={{ color: 'var(--text-muted)' }}>
                Text us at:
              </p>
              <a 
                href={`tel:${companyInfo.phoneRaw}`}
                className="heading-2 block"
                style={{ color: 'var(--accent-text)', fontSize: '1.5rem' }}
              >
                {companyInfo.phone}
              </a>
            </div>

            {/* Text Button */}
            <button
              onClick={handleTextClick}
              className="btn-primary w-full mb-3"
            >
              <MessageSquare size={20} />
              Open Text Message
            </button>

            {/* Quick Info */}
            <div className="text-center">
              <p className="caption" style={{ color: 'var(--text-muted)' }}>
                💬 Available 24/7 for emergencies<br />
                ⚡ Average response time: 5 minutes
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TextUsButton;
